import { useEffect, useState, useCallback } from "react";
import { fetchData } from "../api/client";

function unwrap(res) {
  let d = res?.data ?? res;
  if (d && typeof d === "object" && "data" in d) d = d.data;
  if (d && typeof d === "object" && "data" in d) d = d.data;
  return d;
}

export function useUserFull(userId) {
  const [data, setData] = useState(null);      // { user, projects, logs }
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    try {
      const [userRes, aclRes, logsRes] = await Promise.all([
        fetchData(`/users/${userId}`, "GET"),
        fetchData(`/users/${userId}/acl`, "GET").catch(() => ({ data: { projects: [] } })),
        fetchData(`/users/${userId}/logs?limit=20`, "GET").catch(() => ({ data: [] })),
      ]);

      const u = unwrap(userRes);
      const acl = unwrap(aclRes);
      const l = unwrap(logsRes);

      setData({
        user: u || null,
        projects: Array.isArray(acl?.projects) ? acl.projects : Array.isArray(acl) ? acl : [],
        logs: Array.isArray(l) ? l : Array.isArray(l?.logs) ? l.logs : [],
      });
    } catch (e) {
      setError(e?.response?.data?.message || "Falha ao carregar usuário.");
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load, setData };
}
